// extracted by mini-css-extract-plugin
module.exports = {"icon":"BonusSection__icon--ABKcP","baloon":"BonusSection__baloon--FU_94"};